import { render, staticRenderFns } from "./SurchargeNotesDialog.vue?vue&type=template&id=184d1e04&"
import script from "./SurchargeNotesDialog.vue?vue&type=script&lang=js&"
export * from "./SurchargeNotesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports